import jsPDF from "jspdf";
import "jspdf-autotable";
import { isValidArray } from "../../../utils/MyMUtils";
import { toast } from "react-toastify";

const generatePDFStaffList = (data, column) => {
  const doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a2",
    putOnlyUsedFonts: true,
  });

  const tableColumn = [];
  column.forEach((d) => {
    tableColumn.push(d.key);
  });

  const tableRows = [];

  if (isValidArray(data)) {
    data.forEach((d) => {
      const data = [d.Name,d.org_name,d.facility_name];

      tableRows.push(data);
    });

    doc.autoTable(tableColumn, tableRows, { startY: 10, startX: 0 });
    const date = Date().split(" ");

    const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];

    doc.save(`Staff List.pdf`);
  } else {
    toast.error("There is no data to export.");
  }
};

export default generatePDFStaffList;
